const ErrorView = ({ errorMsg }) => {
	return <div>{errorMsg}</div>;
};

export default ErrorView;
